const actions = {
  FETCH_INVESTOR_REPORTING_TABLE_DATA: 'fund/FETCH_INVESTOR_REPORTING_TABLE_DATA',
}

export default actions
